"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MaterialTimePicker = exports.MaterialTimePickerUnstyled = void 0;
const AccessTime_1 = require("material-ui-icons/AccessTime");
const material_ui_pickers_1 = require("material-ui-pickers");
const react_1 = require("react");
const React = require("react");
require("./time-picker.less");
class MaterialTimePickerUnstyled extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleOnChange = (value) => {
            this.props.onChange && this.props.onChange(value);
        };
    }
    render() {
        const { className = "", disabled = false, label, mask = [/\d/, /\d/, ":", /\d/, /\d/, " ", /a|p/i, "M"], placeholder = "08:00 AM", value } = this.props;
        return (React.createElement("div", { className: `timepicker ${className}` },
            React.createElement(material_ui_pickers_1.TimePicker, { clearable: true, keyboard: true, disabled: disabled, label: label, format: "hh:mm A", value: value, mask: mask, placeholder: placeholder, onChange: this.handleOnChange, keyboardIcon: React.createElement(AccessTime_1.default, null), invalidDateMessage: "" })));
    }
}
exports.MaterialTimePickerUnstyled = MaterialTimePickerUnstyled;
exports.MaterialTimePicker = MaterialTimePickerUnstyled;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/material/timepicker/time-picker.tsx
// module id = 3103
// module chunks = 0